export var CookieConsentLevel;
(function (CookieConsentLevel) {
    /** Technical cookies help to make a website usable by enabling basic
     * functions like page navigation and access to secure areas of the website.
     * The website cannot function properly without these cookies. */
    CookieConsentLevel[CookieConsentLevel["technical"] = 1] = "technical";
    /** Analytics cookies help website owners to understand how visitors
     * interact with websites by collecting and reporting information anonymously. */
    CookieConsentLevel[CookieConsentLevel["analytical"] = 2] = "analytical";
    /** Preference cookies enable a website to remember information that changes
     * the way the website behaves or looks, like your preferred language or the
     * region that you are in. */
    CookieConsentLevel[CookieConsentLevel["preference"] = 3] = "preference";
    /** Marketing cookies are used to track visitors across websites. The intention
     * is to display ads that are relevant and engaging for the individual user and
     * thereby more valuable for publishers and third party advertisers.
     * */
    CookieConsentLevel[CookieConsentLevel["marketing"] = 4] = "marketing";
})(CookieConsentLevel || (CookieConsentLevel = {}));
//# sourceMappingURL=CookieConsentLevel.js.map